import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { AppChallengeUserPopupCompletionRequestPage } from './app-challenge-user-popup-completion-request';
import {PipesModule} from "../../pipes/pipes.module";
import {DirectivesModule} from "../../directives/directives.module";

@NgModule({
  declarations: [
    AppChallengeUserPopupCompletionRequestPage,
  ],
  imports: [
    IonicPageModule.forChild(AppChallengeUserPopupCompletionRequestPage),
    PipesModule,
    DirectivesModule,
  ],
})
export class AppChallengeUserPopupCompletionRequestPageModule {}



// WEBPACK FOOTER //
// ./src/pages/app-challenge-user-popup-completion-request/app-challenge-user-popup-completion-request.module.ts